import React from 'react';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function CheckCircleRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faCheckCircle} {...props} />;
}
